import { ready } from '~/core'

ready('accordion', '.accordion', (accordion) => {
  accordion.querySelectorAll('.accordion-trigger').forEach(function(trigger) {
    const parent = trigger.parentElement;
    
    trigger.addEventListener('click', toggleAccordion);
    trigger.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleAccordion();
      }
    });
    
    function toggleAccordion() {
      if (!parent.classList.contains('is-open')) {
        const openItems = document.querySelectorAll('.accordion .is-open');

        openItems.forEach(function(item) {
          item.classList.remove('is-open');
          item.querySelector('.accordion-trigger').setAttribute('aria-expanded', 'false');
        });

        parent.classList.add('is-open', 'is-opening');
        trigger.setAttribute('aria-expanded', 'true');

        setTimeout(function() {
          const openingItems = document.querySelectorAll('.accordion-item.is-opening');
          openingItems.forEach(function(item) {
            item.classList.remove('is-opening');
          });
        }, 800);
      } else {
        parent.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    }
  });
})
